module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-id.550bdd85.mp4";